import { render, staticRenderFns } from "./ContractsListManagment.vue?vue&type=template&id=2b5765f4&scoped=true&lang=pug&"
import script from "./ContractsListManagment.vue?vue&type=script&lang=ts&"
export * from "./ContractsListManagment.vue?vue&type=script&lang=ts&"
import style0 from "./ContractsListManagment.vue?vue&type=style&index=0&id=2b5765f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5765f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
